import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";
import { SelectedDocumentView } from "@/Documents/Models/UI/IDocumentsTabModel";

/**
 * Component IDs (ordering priority) for the document search header left-side registry.
 * Start with explicit names; consumers can extend this enum when registering.
 */
enum DocumentSearchLeftComponentId {
    // Reserve first slot for custom components (e.g., filters toggles, statistics badges)
    OntarioMdHealthReportManager_PullingErrorToast = 0,
    OntarioMdHealthReportManager_TriggerPullButton = 1
}

/**
 * Props passed to each registered left-side component.
 * Extend as needed when more context is required by extensions.
 */
interface IDocumentSearchLeftComponentRegistryProps {
    selectedView: SelectedDocumentView;
    isCurrentUserClinical: boolean;
}

/**
 * Registry responsible for rendering additional components next to the title
 * in the DocumentSearch header (`additionalLeftComponent`).
 */
class DocumentSearchLeftComponentRegistry extends BaseComponentRegistry<DocumentSearchLeftComponentId, IDocumentSearchLeftComponentRegistryProps> {}

/**
 * React view that renders all registered left-side header components.
 */
const DocumentSearchLeftComponentRegistryView = createRegistryListView(() => DocumentSearchLeftComponentRegistry.getInstance());

export {
    DocumentSearchLeftComponentId,
    DocumentSearchLeftComponentRegistry,
    DocumentSearchLeftComponentRegistryView,
    IDocumentSearchLeftComponentRegistryProps
};
